import { render, staticRenderFns } from "./ValidatableTextarea.vue?vue&type=template&id=7c236be8&"
import script from "./ValidatableTextarea.vue?vue&type=script&lang=js&"
export * from "./ValidatableTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports